export class ElementMatcher {
    static emittedByOrChild(event, selector, action) {
        if (!(event.target instanceof HTMLElement))
            return null;
        return ElementMatcher.findParentOrSelf(event.target, selector, action);
    }
    static emittedBy(event, selector, action) {
        if (!(event.target instanceof HTMLElement))
            return null;
        return ElementMatcher.matches(event.target, selector, action);
    }
    static matches(element, selector, action) {
        if (element && element.matches(selector) && action) {
            action(element);
            return element;
        }
        return null;
    }
    static findParentOrSelf(element, selector, action) {
        let result = element;
        while (result && !result.matches(selector)) {
            result = result.parentElement;
        }
        if (result && action) {
            action(result);
        }
        return result;
    }
}
